var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealsKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.76218C11.5304 3.76218 12.0391 3.97289 12.4142 4.34797C12.7893 4.72304 13 5.23175 13 5.76218M15 5.76218C15.0001 6.34559 14.8726 6.92196 14.6263 7.45087C14.3801 7.97978 14.0212 8.44843 13.5747 8.82396C13.1282 9.19949 12.605 9.4728 12.0417 9.62474C11.4785 9.77668 10.8888 9.80357 10.314 9.70351C9.93867 9.63885 9.54133 9.72085 9.272 9.99018L7.5 11.7622H6V13.2622H4.5V14.7622H2V12.8835C2 12.4855 2.158 12.1035 2.43933 11.8228L6.772 7.49018C7.04133 7.22085 7.12333 6.82351 7.05867 6.44818C6.96413 5.90229 6.98402 5.34271 7.11709 4.80492C7.25015 4.26712 7.49348 3.76282 7.83165 3.324C8.16983 2.88517 8.59547 2.52137 9.08161 2.25567C9.56775 1.98997 10.1038 1.82815 10.6557 1.78047C11.2077 1.73279 11.7636 1.80029 12.2881 1.97869C12.8126 2.15709 13.2943 2.4425 13.7027 2.81683C14.1111 3.19117 14.4373 3.64626 14.6606 4.15328C14.884 4.66029 14.9995 5.20816 15 5.76218Z",
    stroke: "#755FFE",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsKey);
export default __webpack_public_path__ + "static/media/deals-key.83e51883ee03529900ef7b94d8816344.svg";
export { ForwardRef as ReactComponent };